import React, {PureComponent, CSSProperties} from 'react'
import cxs from 'cxs/component'
import Theme from 'Theme'
import {providers, provider} from 'helpers/Providers'
import {Field, Icon, Loading} from 'elements'
import Icomoon from '../elements/Icomoon'

const logo = {
  width: 88.5,
  height: 20
}

const powered = {
  width: 45,
  height: 5
}

interface Props {
  width?: number
}

class Logo extends PureComponent<Props, object> {
  render() {
    const {width: _width, ...props} = this.props
    const width = _width || 200
    if (provider === providers.redsys)
      return <img {...props} width={width} src="/assets/images/redsys.png" />
    const logoHeight = logo.height * width / logo.width
    const poweredHeight = powered.height * width / logo.width
    return (
      <Wrapper {...props}>
        <StyledLogo name="logo" size={logoHeight -15} />
        {/*<StyledCreanimund size={poweredHeight}>TICKET BUS-TRAIN </StyledCreanimund>*/}
        {/*<StyledPowered name="logo" size={poweredHeight} />*/}
      </Wrapper>
    )
  }
}

export default Logo

const Wrapper = cxs('div')({
  textAlign: 'right'
} as CSSProperties)

const icon = {
  display: 'block !important',
  padding: 0
} as CSSProperties

const StyledLogo = cxs(Icomoon)({
  ...icon,
  color: Theme.color.primary
} as CSSProperties)

const StyledPowered = cxs(Icon)(
  ({size}) =>
    ({
      ...icon,
      color: Theme.color.primary,
      marginTop: Theme.common.size.space * size / 20 + 'px'
    } as CSSProperties)
)
const StyledCreanimund = cxs('label')(
  ({size}) =>
    ({
      ...icon,
      marginTop: Theme.common.size.space * size / 20 + 'px'
    } as CSSProperties)
)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Logo.tsx